export default "__VITE_ASSET__CyuK3a$K__"